export { default } from 'common/test-access/access-token.js';
